'use strict';

import Logger from './Logger';
import Util from './Util';
var widgetCookieName = 'lh_widget_%n_pages_counter';
var widgetSystemCookieName = 'lh_widget_system_pages_counter';

function ConditionsValidator(conditions_and, conditions_or, widgetId) {
    /**
     * Make validate function
     * @returns {boolean}
     */
    this.validate = function(need_show_widget) {
        // Get results of conditions validation
        conditions_and = conditions_and || [];
        conditions_or = conditions_or || [];
        var allCheck = conditions_and.map(compile, this);
        var oneOfCheck = conditions_or.map(compile, this);
        var isAll = true
        var isOneOf = true

        // Do we need to show widget
        if (conditions_and.length > 0) {
            isAll = allCheck.length === allCheck.filter(function(item) { return item === true; }).length;
        }

        if (conditions_or.length > 0) {
            isOneOf = oneOfCheck.filter(function(item) { return item === true; }).length > 0;
        }

        function compile(options) {
            return this.compileValidator(
                options.type,
                options.name,
                options.op,
                options.value,
                widgetId,
                need_show_widget
            );
        }

        return Boolean(isAll && isOneOf);
    }

    this.compileValidator = function(type, name, operation, conditionValue, widgetId, need_show_widget) {
        var value;

        switch(type) {
            case 'cookie':
                value = Util.cookie.get(name) || '';
                break;
            case 'fixed_vars':
                value = window.lhWidgetSystem.getWidgetVariablesByWidgetId(widgetId)[name];
                if (name === 'widget_shown') {
                    value = window.lhWidgetSystem.getWidgetVariablesByWidgetId(conditionValue)[name];
                }
                if (name === 'pages_counter') {
                    value = parseInt(Util.cookie.get(widgetSystemCookieName));
                }
                if (name === 'referrer') {
                    value = document.referrer;
                }
                if (name === 'device')
                {
                    if (Util.isMobile()) {
                        value = "mobile";
                    }
                    else {
                        value = "desktop";
                    }
                };
                /*
                FOR EVERY WIDGET. DO NOT REMOVE
                if (name === 'pages_counter') {
                    var currentWidgetCookieName = widgetCookieName.replace('%n', widgetId);
                    value = parseInt(Util.cookie.get(currentWidgetCookieName));
                }*/
                break;
            case 'ls_vars':
                value = window.localStorage.getItem(name) || '';
                break;
            case 'global_vars':
                value = window[name];
                break;
        }

        var isValid;
        // Simple logic
        switch (operation) {
            case 'is':
                isValid = conditionValue === value;
                break;
            case 'not':
                isValid = conditionValue !== value;
                break;
            case 'more':
                isValid = value > conditionValue;
                break;
            case 'less':
                isValid = value < conditionValue;
                break;
            case 'num_more':
                isValid = parseFloat(value) > parseFloat(conditionValue);
                break;
            case 'num_less':
                isValid = parseFloat(value) < parseFloat(conditionValue);
                break;
            case 'contain':
                isValid = value.indexOf(conditionValue, 0) !== -1;
                break;
            case 'not_contain':
                isValid = value.indexOf(conditionValue, 0) === -1;
                break;
            case 'contain_regexp':
                let contain_regexp = new RegExp(conditionValue.replace(/\?/g, '\\?').replace(/\*/g, '\\*'))
                Util.console.log('contain_regexp', contain_regexp)
                isValid = value.match(contain_regexp) && value.match(contain_regexp).length > 0 ? true : false
                break;
            case 'not_contain_regexp':
                let not_contain_regexp = new RegExp(conditionValue.replace(/\?/g, '\\?').replace(/\*/g, '\\*'))
                Util.console.log('not_contain_regexp', not_contain_regexp)
                isValid = !value.match(not_contain_regexp) || value.match(not_contain_regexp).length === 0 ? true : false
                break;
            case 'contains':
                isValid = Boolean(window.document.querySelector(conditionValue))
                break;
            case 'not_contains':
                isValid = Boolean(window.document.querySelector(conditionValue)) ? false : true
                break;
        }

        // Widget shown logic
        if (name === 'widget_shown') {
            switch (operation) {
                case 'is':
                    isValid = value;
                    break;
                case 'not':
                    isValid = !value;
                    break;
            }
        }
        if ( (name === 'timer' || name === 'idle_timer' || name === 'timer_from_the_beginning_of_the_visit') && need_show_widget) {
            isValid = need_show_widget
        }

        Logger.log(
            'Condition',
            [
                'NAME: ' + name,
                'CONDITION VALUE: ' + conditionValue + ', VALUE TYPE ' + typeof conditionValue,
                'REAL VALUE: ' + value + ', VALUE TYPE ' + typeof value,
                'OPERATION: ' + operation,
                'IS VALID: ' + isValid
            ]
        );

        return isValid;
    }
}

export default ConditionsValidator;
